import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import SimpleInput from "../../components/Frequents/SimpleInput";
import SelectBoolean from "../../components/Frequents/SelectBoolean";
import PremiumBadge from "../../components/Frequents/PremiumBadge";
import MomentLocaleUtils from "react-day-picker/moment";
import {
    Container,
    Button,
    Grid,
    Box,
    Typography,
    Dialog,
    DialogTitle,
    DialogActions,
    CircularProgress,
    DialogContent,
    InputAdornment,
    IconButton
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import update from "immutability-helper";
import { set } from "../../actions";
import ClinicUsers from "./ClinicUsers";
import API from "../../actions";
import Loading from "../Common/loading";

import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import Switch from "@material-ui/core/Switch";
import { format, parse, isValid } from "date-fns";
import { Close } from "@material-ui/icons";

const companyInputFields = [
    { id: "companyName", label: "Firmanavn", type: "text", required: true, pro: false, maxLength: 100 },
    { id: "email", label: "Kontormail", type: "text", required: true, pro: true, maxLength: 100 },
    { id: "mobilePay", label: "MobilePay Nummer", type: "number", required: false, pro: true, maxLength: 100 },
    { id: "CVR", label: "CVR-nummer", type: "number", required: false, pro: true, maxLength: 8 },
    { id: "phone", label: "Kontortelefon", type: "number", required: true, pro: true, maxLength: 20 },
    { id: "moms", label: "Momsregistreret", type: "SelectBoolean", required: false, pro: false, maxLength: 100 },
    { id: "address", label: "Firmaadresse", type: "text", required: true, pro: true, maxLength: 100 },
    { id: "town", label: "By", type: "text", required: true, pro: true, maxLength: 100 },
    { id: "post", label: "Postnummer", type: "number", required: true, pro: true, maxLength: 8 },
    { id: "regNumber", label: "Bankregistrering", type: "number", required: false, pro: true, maxLength: 4 },
    { id: "accountNumber", label: "Kontonummer", type: "number", required: false, pro: true, maxLength: 10 }
    // { id: "sharedInvoice", label: "Delte Faktura", type: "SelectBoolean", required: false, pro: true, maxLength: 100 },
];

export default props => {
    const [company, setCompany] = useState({});
    const [openLoading, setOpenLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();
    const therapist = useSelector(state => state.data.therapist);
    const [disconnectConfirmModalOpen, setDisconnectConfirmModalOpen] = useState(false);
    const isDineroConnected = therapist.dineroOrgId && therapist.dineroRefreshToken;

    const [isDineroModelOpen, setIsDineroModelOpen] = useState(false);
    const [checked, setChecked] = React.useState(true);
    const [selectedFromDate, setSelectedFromDate] = useState("");
    const [selectedToDate, setSelectedToDate] = useState("");
    const [error, setError] = useState({
        selectedFromDate: "",
        selectedToDate: ""
    });

    const [toDateFocus, setToDateFocus] = useState(false);
    const [fromDateFocus, setFromDateFocus] = useState(false);

    props.setLocationName();

    const getCompany = async () => {
        try {
            setOpenLoading(true);
            const uCompany = await API.getCompany();
            setCompany(uCompany);
            setOpenLoading(false);
        } catch (ex) {
            console.log(ex);
        }
    };

    useEffect(() => {
        getCompany();
    }, []);

    const updateCompany = async (field, value) => {
        if (company[field] === value) return;
        const newCom = { ...company };
        const olVal = company[field];
        newCom[field] = value;
        setCompany(newCom);
        try {
            API.setCompany(newCom).then(
                data => {},
                err => {
                    // reset to old value
                    const newCom2 = { ...company };
                    newCom2[field] = olVal;
                    setCompany(newCom2);
                    alert(err);
                }
            );

            if (field === "logo") {
                dispatch(set({ therapist: update(therapist, { logo: { $set: value } }) }));
            } else if (field === "moms") {
                dispatch(set({ therapist: update(therapist, { moms: { $set: value } }) }));
            }
        } catch (ex) {
            console.log(ex);
        }
    };

    const getText = txt => {
        const t = txt || "";
        return t.length > 0 ? t.trim() : t;
    };

    const handleDineroConnect = async e => {
        e.preventDefault();

        if (!checked && !selectedFromDate) {
            setError({ ...error, selectedFromDate: "Feltet er påkrævet." });
        } else if (!checked && !selectedToDate) {
            setError({ ...error, selectedToDate: "Feltet er påkrævet." });
        } else {
            const aTag = document.createElement("a");
            const res = await API.getVismaConnectUrl();

            if (res) {
                aTag.setAttribute("href", res);
                aTag.click();
            } else {
                alert("something went wrong");
            }
        }
    };

    const handleDineroConnectModalOpen = () => {
        setIsDineroModelOpen(true);
    };

    const handleDisconnectDinero = async () => {
        try {
            setIsLoading(true);
            await API.disconnectDinero();
            dispatch(
                set({
                    therapist: update(therapist, { dineroOrgId: { $set: "" }, dineroRefreshToken: { $set: "" } })
                })
            );
            setIsLoading(false);
            setDisconnectConfirmModalOpen(false);
        } catch (err) {
            console.log({ err });
            setIsLoading(false);
        }
    };

    const handleChange = event => {
        setChecked(event.target.checked);
        localStorage.setItem("dineroAllDataStatus", event.target.checked);
        if (event.target.checked === true) {
            setSelectedFromDate("");
            setSelectedToDate("");
            localStorage.removeItem("fromDate");
            localStorage.removeItem("toDate");
        }
    };

    const formatDate = (date, formatStr) => {
        return date ? format(date, formatStr) : "";
    };
    const handleSelectFrom = date => {
        setError({ ...error, selectedFromDate: "" });
        setSelectedFromDate(date);
        localStorage.setItem("fromDate", formatDate(date, "yyyy-MM-dd"));
    };

    const handleSelectTo = date => {
        setError({ ...error, selectedToDate: "" });
        setSelectedToDate(date);
        localStorage.setItem("toDate", formatDate(date, "yyyy-MM-dd"));
    };

    const parseDate = (str, formatStr) => {
        const parsedDate = parse(str, formatStr, new Date());
        return isValid(parsedDate) ? parsedDate : undefined;
    };

    const dineroModelClose = () => {
        setIsDineroModelOpen(false);
        setSelectedFromDate("");
        setSelectedToDate("");
        setChecked(true);
        localStorage.removeItem("fromDate");
        localStorage.removeItem("toDate");
        localStorage.removeItem("dineroAllDataStatus");
    };

    const Calendar = (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g opacity="0.5" clip-path="url(#clip0_47_5)">
                <path
                    d="M13.9294 0.941177H12.5176V2.35294C12.5176 2.6353 12.2824 2.82353 12.0471 2.82353C11.8118 2.82353 11.5765 2.6353 11.5765 2.35294V0.941177H4.04706V2.35294C4.04706 2.6353 3.81177 2.82353 3.57647 2.82353C3.34118 2.82353 3.10588 2.6353 3.10588 2.35294V0.941177H1.69412C0.988236 0.941177 0.470589 1.55294 0.470589 2.35294V4.04706H15.5294V2.35294C15.5294 1.55294 14.6824 0.941177 13.9294 0.941177ZM0.470589 5.0353V13.6471C0.470589 14.4941 0.988236 15.0588 1.74118 15.0588H13.9765C14.7294 15.0588 15.5765 14.4471 15.5765 13.6471V5.0353H0.470589ZM4.65882 12.9412H3.52941C3.34118 12.9412 3.15294 12.8 3.15294 12.5647V11.3882C3.15294 11.2 3.29412 11.0118 3.52941 11.0118H4.70588C4.89412 11.0118 5.08235 11.1529 5.08235 11.3882V12.5647C5.03529 12.8 4.89412 12.9412 4.65882 12.9412ZM4.65882 8.70588H3.52941C3.34118 8.70588 3.15294 8.56471 3.15294 8.32941V7.15294C3.15294 6.96471 3.29412 6.77647 3.52941 6.77647H4.70588C4.89412 6.77647 5.08235 6.91765 5.08235 7.15294V8.32941C5.03529 8.56471 4.89412 8.70588 4.65882 8.70588ZM8.42353 12.9412H7.24706C7.05882 12.9412 6.87059 12.8 6.87059 12.5647V11.3882C6.87059 11.2 7.01177 11.0118 7.24706 11.0118H8.42353C8.61176 11.0118 8.8 11.1529 8.8 11.3882V12.5647C8.8 12.8 8.65882 12.9412 8.42353 12.9412ZM8.42353 8.70588H7.24706C7.05882 8.70588 6.87059 8.56471 6.87059 8.32941V7.15294C6.87059 6.96471 7.01177 6.77647 7.24706 6.77647H8.42353C8.61176 6.77647 8.8 6.91765 8.8 7.15294V8.32941C8.8 8.56471 8.65882 8.70588 8.42353 8.70588ZM12.1882 12.9412H11.0118C10.8235 12.9412 10.6353 12.8 10.6353 12.5647V11.3882C10.6353 11.2 10.7765 11.0118 11.0118 11.0118H12.1882C12.3765 11.0118 12.5647 11.1529 12.5647 11.3882V12.5647C12.5647 12.8 12.4235 12.9412 12.1882 12.9412ZM12.1882 8.70588H11.0118C10.8235 8.70588 10.6353 8.56471 10.6353 8.32941V7.15294C10.6353 6.96471 10.7765 6.77647 11.0118 6.77647H12.1882C12.3765 6.77647 12.5647 6.91765 12.5647 7.15294V8.32941C12.5647 8.56471 12.4235 8.70588 12.1882 8.70588Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_47_5">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
    return (
        <div style={{ marginTop: "20px" }}>
            <Container maxWidth="lg" style={{ height: "100%" }}>
                <Grid container spacing={3}>
                    {companyInputFields.map(field => {
                        if (field.type === "SelectBoolean")
                            return (
                                <Grid key={field.id} item lg={4} style={{ width: "100%" }}>
                                    <SelectBoolean
                                        name={field.id}
                                        text={field.label}
                                        prop={company[field.id] || false}
                                        choice1="Ja"
                                        choice2="Nej"
                                        value1={true}
                                        value2={false}
                                        changeValue={value => updateCompany(field.id, value)}
                                        disabled={field.pro && therapist.plan !== "pro"}
                                    />
                                </Grid>
                            );

                        return (
                            <Grid key={field.id} item lg={4} style={{ width: "100%" }}>
                                <SimpleInput
                                    name={field.id}
                                    text={field.label}
                                    required={field.required}
                                    type={field.type}
                                    prop={getText(company[field.id])}
                                    changeValue={value => updateCompany(field.id, value)}
                                    disabled={field.pro && therapist.plan !== "pro"}
                                    maxLength={field.maxLength}
                                />
                            </Grid>
                        );
                    })}

                    <Grid item lg={4} style={{ width: "100%" }}>
                        <SimpleInput
                            name="themeColor2"
                            text="Temafarve"
                            type="color"
                            disabled={therapist.plan !== "pro"}
                            prop={(JSON.parse(therapist.colors) || ["", "#35408e"])[1]}
                            changeValue={value =>
                                dispatch(
                                    set({
                                        therapist: update(therapist, { colors: { $set: JSON.stringify(["", value]) } })
                                    })
                                )
                            }
                        />
                        <Button
                            disabled={therapist.plan !== "pro"}
                            onClick={() =>
                                dispatch(set({ therapist: update(therapist, { colors: { $set: '["", "#35408e"]' } }) }))
                            }>
                            Original
                        </Button>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Button
                            style={{
                                background: isDineroConnected
                                    ? "red"
                                    : "linear-gradient(45deg, #5AC3FF 0%, #0550C8 100%)",
                                color: "white"
                            }}
                            onClick={
                                isDineroConnected
                                    ? () => setDisconnectConfirmModalOpen(true)
                                    : handleDineroConnectModalOpen
                            }>
                            <Box
                                style={{
                                    padding: "7px",
                                    paddingBottom: "0px",
                                    backgroundColor: "white",
                                    borderRadius: "7px",
                                    marginRight: "11px"
                                }}>
                                <img src="dinero-logo.png" alt="dinero-logo" />{" "}
                            </Box>{" "}
                            {isDineroConnected ? "Fjern integration" : "integrer med Dinero"}
                        </Button>
                        {!isDineroConnected ? (
                            <Typography
                                variant="subtitle2"
                                style={{
                                    marginTop: "20px"
                                }}>
                                Bemærk: Kræver at din konto har et Pro abonnement
                            </Typography>
                        ) : null}
                    </Grid>
                    <Grid item lg={4} style={{ width: "100%" }}>
                        <input
                            id="upload-logo-file"
                            name="companyLogoSetting"
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            style={{ display: "none" }}
                            disabled={therapist.plan !== "pro"}
                            onChange={event => {
                                const allowTypes = ["image/jpg", "image/jpeg", "image/png"];
                                if (allowTypes.indexOf(event.target.files[0].type) === -1) {
                                    alert("Fejl: din fil understøttes ikke. Upload fil med filtypen JPG, JPEG, PNG.");
                                    return;
                                }
                                if (event.target.files[0].size > 5120000) {
                                    alert("Fejl: Filstørrelsen er for stor. Upload fil mindre end 5 MB.");
                                    return;
                                }
                                const reader = new FileReader();
                                reader.readAsDataURL(event.target.files[0]);
                                reader.onload = () => updateCompany("logo", reader.result);
                                // dispatch(set({ therapist: update(therapist, { logo: { $set: reader.result } }) }));
                            }}
                        />
                        <label htmlFor="upload-logo-file">
                            <Button
                                variant="contained"
                                color="default"
                                startIcon={<CloudUploadIcon />}
                                component="span"
                                style={{ margin: "10px 0 10px 0" }}>
                                Upload logo
                                {therapist.plan !== "pro" && <PremiumBadge />}
                            </Button>
                        </label>
                    </Grid>
                </Grid>
            </Container>
            <Container>
                <Grid>
                    <ClinicUsers></ClinicUsers>
                </Grid>
            </Container>
            <Loading open={openLoading} />
            <Dialog maxWidth="md" open={disconnectConfirmModalOpen} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Er du sikker på, at du vil afbryde forbindelsen?</DialogTitle>
                <DialogActions>
                    {isLoading ? (
                        <CircularProgress style={{ marginRight: "10px" }} />
                    ) : (
                        <>
                            <Button onClick={handleDisconnectDinero} color="primary">
                                Yes
                            </Button>
                            <Button
                                onClick={() => {
                                    setDisconnectConfirmModalOpen(false);
                                }}
                                color="primary">
                                No
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth="lg"
                open={isDineroModelOpen}
                aria-labelledby="form-dialog-title"
                PaperProps={{
                    style: {
                        width: "100%",
                        minHeight: "350px",
                        borderRadius: "25px",
                        padding: "40px",
                        maxWidth: "700px",
                        overflowY: "visible",
                        margin: "10px"
                    },
                    className: "date-picker-popup"
                }}
                className="date-picker-popup">
                <Grid onClick={dineroModelClose}>
                    <Close
                        style={{
                            color: "#00000059",
                            position: "absolute",
                            right: "40px",
                            fontSize: "40px",
                            cursor: "pointer"
                        }}
                        className="close-icon"
                    />
                </Grid>
                <DialogTitle
                    id="form-dialog-title"
                    style={{ color: "black", fontSize: "22px !important", padding: "0px", paddingBottom: "5px" }}>
                    Integration indstillinger
                </DialogTitle>
                <Typography
                    variant="subtitle2"
                    style={{ color: "#00000080", fontSize: "14px !important", padding: "0px" }}>
                    {" "}
                    Vælg hvad der skal overføres
                </Typography>
                <DialogContent
                    style={{
                        padding: "0px",
                        paddingTop: "30px",
                        overflowY: "visible",
                        flex: "initial",
                        minHeight: "150px",
                        "@media screen and (max-width:600px)": {
                            minHeight: "220px"
                        }
                    }}
                    className="date-picker-content">
                    <Grid container spacing={3} item xs={12} style={{ margin: "0px", padding: "0px" }}>
                        <Grid item style={{ display: "flex", columnGap: "10px", alignItems: "center", padding: "0px" }}>
                            <Typography variant="subtitle2" className={!checked ? "active-text" : "inActive-text"}>
                                Bestemt tidsperiode
                            </Typography>
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={handleChange}
                                className="custome-switch"
                            />
                            <Typography variant="subtitle2" className={checked ? "active-text" : "inActive-text"}>
                                Overfør alt
                            </Typography>
                        </Grid>
                        {!checked && (
                            <Grid
                                item
                                xs={12}
                                container
                                style={{ padding: "0px", paddingTop: "30px", flexWrap: "wrap", rowGap: "20px" }}>
                                <Grid item sm={6} xs={12} style={{ position: "relative" }} className="todate-input">
                                    <Typography variant="subtitle2" style={{ color: "rgba(0, 0, 0, 0.5)" }}>
                                        Fra{" "}
                                    </Typography>
                                    <DayPickerInput
                                        formatDate={date => formatDate(date, "yyyy-MM-dd")}
                                        parseDate={str => parseDate(str, "yyyy-MM-dd")}
                                        placeholder="Vælg en dato"
                                        value={selectedFromDate}
                                        onDayChange={handleSelectFrom}
                                        onDayPickerShow={() => setFromDateFocus(true)}
                                        onDayPickerHide={() => setFromDateFocus(false)}
                                        inputProps={{
                                            IconButton,
                                            style: {
                                                width: "90%",
                                                padding: "10px 0px 10px 0px",
                                                border: "none",
                                                borderBottom: "1px solid #000",
                                                borderRadius: "0px",
                                                fontSize: "16px",
                                                color: "black",
                                                "& focus-visible": {
                                                    outline: "none"
                                                },
                                                "@media screen and (max-width:767px)": {
                                                    width: "100%"
                                                }
                                            },
                                            className: "custom-day-picker-input"
                                        }}
                                        style={{
                                            width: "100%"
                                        }}
                                        dayPickerProps={{
                                            locale: "da",
                                            localeUtils: MomentLocaleUtils
                                        }}
                                    />
                                    <svg
                                        className={fromDateFocus ? "active-class" : ""}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none">
                                        <g opacity="0.5" clip-path="url(#clip0_47_5)">
                                            <path
                                                d="M13.9294 0.941177H12.5176V2.35294C12.5176 2.6353 12.2824 2.82353 12.0471 2.82353C11.8118 2.82353 11.5765 2.6353 11.5765 2.35294V0.941177H4.04706V2.35294C4.04706 2.6353 3.81177 2.82353 3.57647 2.82353C3.34118 2.82353 3.10588 2.6353 3.10588 2.35294V0.941177H1.69412C0.988236 0.941177 0.470589 1.55294 0.470589 2.35294V4.04706H15.5294V2.35294C15.5294 1.55294 14.6824 0.941177 13.9294 0.941177ZM0.470589 5.0353V13.6471C0.470589 14.4941 0.988236 15.0588 1.74118 15.0588H13.9765C14.7294 15.0588 15.5765 14.4471 15.5765 13.6471V5.0353H0.470589ZM4.65882 12.9412H3.52941C3.34118 12.9412 3.15294 12.8 3.15294 12.5647V11.3882C3.15294 11.2 3.29412 11.0118 3.52941 11.0118H4.70588C4.89412 11.0118 5.08235 11.1529 5.08235 11.3882V12.5647C5.03529 12.8 4.89412 12.9412 4.65882 12.9412ZM4.65882 8.70588H3.52941C3.34118 8.70588 3.15294 8.56471 3.15294 8.32941V7.15294C3.15294 6.96471 3.29412 6.77647 3.52941 6.77647H4.70588C4.89412 6.77647 5.08235 6.91765 5.08235 7.15294V8.32941C5.03529 8.56471 4.89412 8.70588 4.65882 8.70588ZM8.42353 12.9412H7.24706C7.05882 12.9412 6.87059 12.8 6.87059 12.5647V11.3882C6.87059 11.2 7.01177 11.0118 7.24706 11.0118H8.42353C8.61176 11.0118 8.8 11.1529 8.8 11.3882V12.5647C8.8 12.8 8.65882 12.9412 8.42353 12.9412ZM8.42353 8.70588H7.24706C7.05882 8.70588 6.87059 8.56471 6.87059 8.32941V7.15294C6.87059 6.96471 7.01177 6.77647 7.24706 6.77647H8.42353C8.61176 6.77647 8.8 6.91765 8.8 7.15294V8.32941C8.8 8.56471 8.65882 8.70588 8.42353 8.70588ZM12.1882 12.9412H11.0118C10.8235 12.9412 10.6353 12.8 10.6353 12.5647V11.3882C10.6353 11.2 10.7765 11.0118 11.0118 11.0118H12.1882C12.3765 11.0118 12.5647 11.1529 12.5647 11.3882V12.5647C12.5647 12.8 12.4235 12.9412 12.1882 12.9412ZM12.1882 8.70588H11.0118C10.8235 8.70588 10.6353 8.56471 10.6353 8.32941V7.15294C10.6353 6.96471 10.7765 6.77647 11.0118 6.77647H12.1882C12.3765 6.77647 12.5647 6.91765 12.5647 7.15294V8.32941C12.5647 8.56471 12.4235 8.70588 12.1882 8.70588Z"
                                                fill="black"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_47_5">
                                                <rect width="16" height="16" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    {error.selectedFromDate && (
                                        <span style={{ color: "#dc3232" }}>{error.selectedFromDate}</span>
                                    )}
                                </Grid>
                                <Grid item sm={6} xs={12} style={{ position: "relative" }}>
                                    <Typography variant="subtitle2" style={{ color: "rgba(0, 0, 0, 0.5)" }}>
                                        Til{" "}
                                    </Typography>
                                    <DayPickerInput
                                        formatDate={date => formatDate(date, "yyyy-MM-dd")}
                                        parseDate={str => parseDate(str, "yyyy-MM-dd")}
                                        placeholder="Vælg en dato"
                                        value={selectedToDate}
                                        onDayChange={handleSelectTo}
                                        onDayPickerShow={() => setToDateFocus(true)}
                                        onDayPickerHide={() => setToDateFocus(false)}
                                        inputProps={{
                                            style: {
                                                width: "100%",
                                                padding: "10px 0px 10px 0px",
                                                border: "none",
                                                borderBottom: "1px solid #000",
                                                borderRadius: "0px",
                                                fontSize: "16px",
                                                color: "black"
                                            },
                                            className: "custom-day-picker-input"
                                        }}
                                        style={{
                                            width: "100%"
                                        }}
                                        dayPickerProps={{
                                            locale: "da",
                                            localeUtils: MomentLocaleUtils
                                        }}
                                    />
                                    <svg
                                        className={toDateFocus ? "active-class" : ""}
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none">
                                        <g opacity="0.5" clip-path="url(#clip0_47_5)">
                                            <path
                                                d="M13.9294 0.941177H12.5176V2.35294C12.5176 2.6353 12.2824 2.82353 12.0471 2.82353C11.8118 2.82353 11.5765 2.6353 11.5765 2.35294V0.941177H4.04706V2.35294C4.04706 2.6353 3.81177 2.82353 3.57647 2.82353C3.34118 2.82353 3.10588 2.6353 3.10588 2.35294V0.941177H1.69412C0.988236 0.941177 0.470589 1.55294 0.470589 2.35294V4.04706H15.5294V2.35294C15.5294 1.55294 14.6824 0.941177 13.9294 0.941177ZM0.470589 5.0353V13.6471C0.470589 14.4941 0.988236 15.0588 1.74118 15.0588H13.9765C14.7294 15.0588 15.5765 14.4471 15.5765 13.6471V5.0353H0.470589ZM4.65882 12.9412H3.52941C3.34118 12.9412 3.15294 12.8 3.15294 12.5647V11.3882C3.15294 11.2 3.29412 11.0118 3.52941 11.0118H4.70588C4.89412 11.0118 5.08235 11.1529 5.08235 11.3882V12.5647C5.03529 12.8 4.89412 12.9412 4.65882 12.9412ZM4.65882 8.70588H3.52941C3.34118 8.70588 3.15294 8.56471 3.15294 8.32941V7.15294C3.15294 6.96471 3.29412 6.77647 3.52941 6.77647H4.70588C4.89412 6.77647 5.08235 6.91765 5.08235 7.15294V8.32941C5.03529 8.56471 4.89412 8.70588 4.65882 8.70588ZM8.42353 12.9412H7.24706C7.05882 12.9412 6.87059 12.8 6.87059 12.5647V11.3882C6.87059 11.2 7.01177 11.0118 7.24706 11.0118H8.42353C8.61176 11.0118 8.8 11.1529 8.8 11.3882V12.5647C8.8 12.8 8.65882 12.9412 8.42353 12.9412ZM8.42353 8.70588H7.24706C7.05882 8.70588 6.87059 8.56471 6.87059 8.32941V7.15294C6.87059 6.96471 7.01177 6.77647 7.24706 6.77647H8.42353C8.61176 6.77647 8.8 6.91765 8.8 7.15294V8.32941C8.8 8.56471 8.65882 8.70588 8.42353 8.70588ZM12.1882 12.9412H11.0118C10.8235 12.9412 10.6353 12.8 10.6353 12.5647V11.3882C10.6353 11.2 10.7765 11.0118 11.0118 11.0118H12.1882C12.3765 11.0118 12.5647 11.1529 12.5647 11.3882V12.5647C12.5647 12.8 12.4235 12.9412 12.1882 12.9412ZM12.1882 8.70588H11.0118C10.8235 8.70588 10.6353 8.56471 10.6353 8.32941V7.15294C10.6353 6.96471 10.7765 6.77647 11.0118 6.77647H12.1882C12.3765 6.77647 12.5647 6.91765 12.5647 7.15294V8.32941C12.5647 8.56471 12.4235 8.70588 12.1882 8.70588Z"
                                                fill="black"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_47_5">
                                                <rect width="16" height="16" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    {error.selectedToDate && (
                                        <span style={{ color: "#dc3232" }}>{error.selectedToDate}</span>
                                    )}
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions style={{ justifyContent: "flex-start", padding: "0px" }}>
                    <Button
                        onClick={handleDineroConnect}
                        color="primary"
                        style={{
                            backgroundColor: "#0B54B3",
                            color: "white",
                            padding: "12px 30px",
                            borderRadius: "6px",
                            textTransform: "capitalize",
                            marginTop: "40px"
                        }}>
                        Integrer Dinero
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
